
if (!customElements.get("cart-remove")) {
  class CartRemove extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClickViaLine.bind(this);
    }

    async getCurrentCartItems() {
      const response = await fetch('/cart.js', { method: "GET" });
      const cartJSON = await response.json();

      return cartJSON.items;
    }

    async handleClickViaLine(event) {
      /* Fix for item keys not working:
        Shopify API is currently disregarding item keys and only using the variant ID portion of the key
        This impacts updating items that may have the same variant ID, like bundle items
        In order to update bundle items correctly, we are using the array of numbers send to update.js
        This requires sending an array of quantities for every item in the cart
      */
      event.preventDefault();

      const cartItems = await this.getCurrentCartItems();

      const updates = cartItems.map((item) => item.quantity);
      const cartKeyMap = cartItems.map((item) => item.key);
      const cartVariantMap = cartItems.map((item) => item.variant_id);
      const removedKeys = this.getAttribute("data-keys").split(',');

      removedKeys.forEach(key => {
        const keyIndex = cartKeyMap.indexOf(key);
        if (keyIndex > -1) {
          updates[keyIndex] = 0;
        }
      });

      const feeVariantIds = new Set();
      (window.coolers || []).forEach(c => feeVariantIds.add(String(c.variant_id)));
      if (window.warmWeather?.variantId) feeVariantIds.add(String(window.warmWeather.variantId));

      const countRemainingTriggers = () => {
        let total = 0;
        cartItems.forEach(item => {
          if (feeVariantIds.has(String(item.variant_id))) return;
          if (item.properties?._isWarmWeatherShippingProduct) return;
          if (removedKeys.includes(item.key)) return;
          total += item.quantity;
        });
        return total;
      };

      if (this.hasAttribute("data-coolers")) {
        const coolers = this.dataset.coolers.split(',');
        const coolerConfigs = window.coolers || [];

        coolers.forEach(coolerVariantId => {
          const config = coolerConfigs.find(c => String(c.variant_id) === String(coolerVariantId));
          const mode = config?.mode || 'per_triggering_item';
          const keyIndex = cartVariantMap.indexOf(coolerVariantId);

          if (keyIndex === -1) return;

          if (mode === 'per_triggering_item') {
            updates[keyIndex] = countRemainingTriggers();
          } else {
            const hasOtherTriggers = cartItems.some(item =>
              !feeVariantIds.has(String(item.variant_id)) &&
              !item.properties?._isWarmWeatherShippingProduct &&
              !removedKeys.includes(item.key)
            );
            if (!hasOtherTriggers) {
              updates[keyIndex] = 0;
            }
          }
        });
      }

      if (this.hasAttribute("data-warm-weather-variant")) {
        const variantId = this.getAttribute("data-warm-weather-variant");
        const wwMode = this.getAttribute("data-warm-weather-mode") || "per_order";
        const keyIndex = cartVariantMap.indexOf(variantId);

        if (keyIndex > -1) {
          if (wwMode === 'per_triggering_item') {
            updates[keyIndex] = countRemainingTriggers();
          } else {
            const hasOtherTriggers = cartItems.some(item =>
              !feeVariantIds.has(String(item.variant_id)) &&
              !item.properties?._isWarmWeatherShippingProduct &&
              !removedKeys.includes(item.key)
            );
            if (!hasOtherTriggers) {
              updates[keyIndex] = 0;
            }
          }
        }
      }

      // Standard update.js POST, same as in handleClick
      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    handleClick(event) {
      event.preventDefault();

      const updates = {};
      const keys = this.getAttribute("data-keys").split(',');

      keys.forEach(key => {
        updates[key] = 0;
      });

      if (this.hasAttribute("data-coolers")) {
        const coolers = this.dataset.coolers.split(',');
        coolers.forEach(coolerVariantId => {
          updates[coolerVariantId] = 0;
        });
      }

      if (this.hasAttribute("data-warm-weather-variant")) {
        updates[`${this.getAttribute("data-warm-weather-variant")}`] = 0;
      }

      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("cart-remove", CartRemove);
}
